import type { Annotation, ToolbarPosition } from '../core/types'
import { showToast, hideToast } from './toast'

export class DetachedPanel {
  private panelEl: HTMLElement | null = null

  constructor(
    private container: HTMLElement,
    private onDelete?: (id: string) => void,
    private position: ToolbarPosition = 'bottom-right',
  ) {}

  update(otherBreakpoint: Annotation[], detached: Annotation[]): void {
    this.remove()
    if (otherBreakpoint.length === 0 && detached.length === 0) return

    const panel = document.createElement('div')
    panel.className = `remarq-detached-panel remarq-pos-${this.position}`

    if (otherBreakpoint.length > 0) {
      this.renderSection(panel, `Other viewport (${otherBreakpoint.length})`, otherBreakpoint, 'other')
    }

    if (detached.length > 0) {
      this.renderSection(panel, `Detached (${detached.length})`, detached, 'detached')
    }

    this.container.appendChild(panel)
    this.panelEl = panel
  }

  destroy(): void {
    this.remove()
    hideToast()
  }

  private renderSection(
    panel: HTMLElement,
    title: string,
    annotations: Annotation[],
    type: 'other' | 'detached',
  ): void {
    const header = document.createElement('div')
    header.className = 'remarq-detached-header'
    header.textContent = title
    panel.appendChild(header)

    for (const ann of annotations) {
      const item = document.createElement('div')
      item.className = 'remarq-detached-item'

      const info = document.createElement('div')
      info.className = 'remarq-detached-info'

      const comment = document.createElement('div')
      comment.className = 'remarq-detached-comment'
      comment.textContent = ann.comment

      const elDesc = document.createElement('div')
      elDesc.className = 'remarq-detached-element'
      const fp = ann.fingerprint
      let desc = `<${fp.tagName}>`
      if (fp.textContent) desc += ` "${fp.textContent}"`
      if (fp.dataAnnotate) desc += ` [${fp.dataAnnotate}]`
      if (type === 'other') desc += ` — ${ann.viewportBucket}px`
      elDesc.textContent = desc

      info.appendChild(comment)
      info.appendChild(elDesc)
      item.appendChild(info)

      if (type === 'other') {
        item.style.cursor = 'pointer'
        item.addEventListener('click', () => {
          showToast(this.container, `Annotation created at ${ann.viewportBucket}px width. Resize viewport to view.`)
        })
      } else {
        const deleteBtn = document.createElement('button')
        deleteBtn.className = 'remarq-detached-delete'
        deleteBtn.textContent = '\u00d7'
        deleteBtn.addEventListener('click', () => {
          this.onDelete?.(ann.id)
        })
        item.appendChild(deleteBtn)
      }

      panel.appendChild(item)
    }
  }

  private remove(): void {
    if (this.panelEl) {
      this.panelEl.remove()
      this.panelEl = null
    }
  }
}
